<template>
  <page-edicion :fluid="true">
    <formulario-oferta />
  </page-edicion>
</template>

<script>
import FormularioOferta from "./FormularioOferta/FormularioOferta";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

export default {
  components: { FormularioOferta },
  async beforeRouteUpdate(to, from, next) {
    const ofertaStore = useOfertaFormStore();
    ofertaStore.$reset();
    await ofertaStore.cargaInicialDeOferta(to.params.id);
    next();
  },
  async beforeRouteEnter(to, from, next) {
    const ofertaStore = useOfertaFormStore();
    ofertaStore.$reset();
    await ofertaStore.cargaInicialDeOferta(to.params.id);
    next();
  },
};
</script>
